import { isVocDomain } from '../../routes';
import { ProjectTaskDetailsDTO } from '../../api/project/project.types';
import { NextTaskAction } from './useClientScriptControl.types';
import { getFinalUrl } from '../url.utils';
import { getDomain } from 'tldts';

const TASK_CONTINUE_VALUE = 'continue';

export async function getNextTaskAction(
  nextTask: ProjectTaskDetailsDTO | undefined,
): Promise<NextTaskAction> {
  if (!nextTask) {
    return {
      action: 'finished',
    };
  }
  if (nextTask.website_testing_url && nextTask.website_testing_url !== TASK_CONTINUE_VALUE) {
    return {
      action: 'redirect',
      params: {
        task_uuid: nextTask.task_uuid,
        url: await getFinalUrl(nextTask.website_testing_url),
      },
    };
  }
  return {
    action: 'continue',
    params: {
      task_uuid: nextTask.task_uuid,
    },
  };
}

/**
 * Validates the origin of the message against the test URL
 * we check for protocol and domain match
 * or known Voc domains.
 * @param origin
 * @param testUrl
 */
export function isValidMessageSource(origin: string | undefined, testUrl: string | undefined) {
  if (!origin) {
    console.error('ClientScriptControl: Validating origin - missing origin');
    return false;
  }

  if (isVocDomain(origin)) {
    return true;
  }

  if (!testUrl) {
    console.error('ClientScriptControl: Validating origin - missing testUrl');
    return false;
  }

  try {
    const testUrlObj = new URL(testUrl);
    const messageObj = new URL(origin);
    if (messageObj.protocol !== testUrlObj.protocol) {
      console.error('ClientScriptControl: Validating origin - protocol mismatch');
      return false;
    }

    const originDomain = getDomain(origin);
    const testUrlDomain = getDomain(testUrl);

    return originDomain === testUrlDomain;
  } catch (error) {
    console.error('ClientScriptControl: Validating origin - invalid URL format');
    return false;
  }
}
